import { APP_ACTION_TYPES } from './actions';

const initState = {
  shareData: {
    title: '',
    desc: '',
    image: '',
    link: '',
  },
  isSensorInit: false,
  platform: '',
  device: '',
};

const appReducer = (state, action = {}) => {
  const payload = action.payload || {};
  switch (action.type) {
    default:
      return {
        ...state,
        ...payload,
      };
  }
};

export { initState, appReducer, APP_ACTION_TYPES };
